<template>
<div>
    <users v-if="users"> </users>
</div>
</template>

<script>
import users from './Users-info.vue'

export default {
    components:{
        users
    },
    data(){
        return{
            users:true
        }
    },
    methods:{
        
    }    
}
</script>
